import { createUserFacingError } from './errors'

export async function getCroppedImg(
  imageSrc: string,
  pixelCrop: { x: number; y: number; width: number; height: number },
  outputWidth: number,
  outputHeight: number,
): Promise<Blob> {
  const image = await loadImage(imageSrc)

  const canvas = document.createElement('canvas')
  canvas.width = outputWidth
  canvas.height = outputHeight
  const ctx = canvas.getContext('2d')

  if (!ctx) {
    throw createUserFacingError('We could not prepare the image for cropping.')
  }

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    outputWidth,
    outputHeight,
  )

  return new Promise<Blob>((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob) {
          resolve(blob)
        } else {
          reject(createUserFacingError('We could not prepare the image for cropping.'))
        }
      },
      'image/webp',
      0.9,
    )
  })
}

async function loadImage(src: string): Promise<HTMLImageElement> {
  const objectUrl = await toObjectUrl(src)
  try {
    return await new Promise<HTMLImageElement>((resolve, reject) => {
      const img = new Image()
      img.addEventListener('load', () => resolve(img))
      img.addEventListener('error', () => reject(createUserFacingError('We could not load that image.')))
      img.src = objectUrl
    })
  } finally {
    if (objectUrl !== src) URL.revokeObjectURL(objectUrl)
  }
}

async function toObjectUrl(src: string): Promise<string> {
  if (src.startsWith('blob:') || src.startsWith('data:')) return src
  const res = await fetch(src, { mode: 'cors', credentials: 'omit' })
  if (!res.ok) throw createUserFacingError('We could not load that image.')
  return URL.createObjectURL(await res.blob())
}
